var _rect, _rect2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#A1A5B7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1344_5697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1344_5697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5138 19.981C17.4069 19.981 17.3066 19.9651 17.213 19.9333C17.1195 19.9016 17.0326 19.8476 16.9524 19.7714L12.8622 15.8857C12.782 15.8095 12.7251 15.727 12.6917 15.6381C12.6583 15.5492 12.6416 15.454 12.6416 15.3524C12.6416 15.2508 12.6583 15.1556 12.6917 15.0667C12.7251 14.9778 12.782 14.8952 12.8622 14.819L14.5664 13.2C14.6466 13.1238 14.7335 13.0698 14.8271 13.0381C14.9206 13.0063 15.0209 12.9905 15.1278 12.9905C15.2348 12.9905 15.335 13.0063 15.4286 13.0381C15.5221 13.0698 15.609 13.1238 15.6892 13.2L19.7795 17.0857C19.8597 17.1619 19.9165 17.2444 19.9499 17.3333C19.9833 17.4222 20 17.5175 20 17.619C20 17.7206 19.9833 17.8159 19.9499 17.9048C19.9165 17.9936 19.8597 18.0762 19.7795 18.1524L18.0752 19.7714C17.995 19.8476 17.9081 19.9016 17.8145 19.9333C17.721 19.9651 17.6207 19.981 17.5138 19.981ZM17.5138 18.1714L18.0952 17.619L15.1479 14.819L14.5664 15.3714L17.5138 18.1714ZM6.50627 20C6.39933 20 6.29574 19.981 6.19549 19.9429C6.09524 19.9048 6.00501 19.8476 5.92481 19.7714L4.2406 18.1714C4.1604 18.0952 4.10025 18.0095 4.06015 17.9143C4.02005 17.819 4 17.7206 4 17.619C4 17.5175 4.02005 17.4222 4.06015 17.3333C4.10025 17.2444 4.1604 17.1619 4.2406 17.0857L8.49123 13.0476H10.1955L10.8772 12.4L7.56892 9.25714H6.42607L4 6.95238L6.26566 4.8L8.69173 7.10476V8.19048L12 11.3333L14.3258 9.12381L13.4637 8.30476L14.5865 7.23809H12.3208L11.7594 6.70476L14.6065 4L15.1679 4.53333V6.68571L16.2907 5.61905L19.1378 8.32381C19.3651 8.53968 19.5388 8.78413 19.6591 9.05714C19.7794 9.33016 19.8396 9.61905 19.8396 9.92381C19.8396 10.2286 19.7794 10.5206 19.6591 10.8C19.5388 11.0794 19.3651 11.327 19.1378 11.5429L17.4336 9.92381L16.3108 10.9905L15.4687 10.1905L11.3183 14.1333V15.7333L7.06767 19.7714C6.98747 19.8476 6.90058 19.9048 6.80702 19.9429C6.71345 19.981 6.6132 20 6.50627 20ZM6.50627 18.1714L9.91479 14.9333V14.381H9.33333L5.92481 17.619L6.50627 18.1714ZM6.50627 18.1714L5.92481 17.619L6.22556 17.8857L6.50627 18.1714Z",
    fill: "#F16522"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApart);
export default __webpack_public_path__ + "static/media/apart.1d6ceef5.svg";
export { ForwardRef as ReactComponent };